.lista {
  display: flex;
  gap: var(--s-2);
  border-bottom: var(--bw-hair) solid var(--border-hair);
  overflow-x: auto;
  scrollbar-width: none;
}
.lista::-webkit-scrollbar {
  display: none;
}
/* Texto gris, la activa en tinta con la regla de 2px accent pisando el borde de abajo. */
.tab {
  display: inline-flex;
  align-items: center;
  gap: var(--s-4);
  height: var(--h-control-md);
  padding: 0 var(--s-5);
  margin-bottom: calc(-1 * var(--bw-hair));
  border: none;
  border-bottom: var(--bw-thick) solid transparent;
  border-radius: var(--r-xs) var(--r-xs) 0 0;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--text-muted);
  box-shadow: none;
  transition:
    color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}
.tab[aria-selected="true"] {
  color: var(--text-strong);
  border-bottom-color: var(--border-brand);
}
@media (hover: hover) {
  .tab:hover {
    color: var(--text-strong);
  }
}
.tab:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
/* El contador es una píldora mono: surface con texto gris; en la activa, accent-100 con texto accent. */
.contador {
  padding: var(--s-1) var(--s-3);
  border-radius: var(--r-full);
  background: var(--surface-sunken);
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-3xs);
  font-weight: var(--fw-medium);
  line-height: 1.5;
  color: var(--text-muted);
}
.tab[aria-selected="true"] .contador {
  background: var(--surface-brand-soft);
  color: var(--text-brand);
}
/* Ámbar mientras no está activa: hay algo esperando en esa pestaña. */
.tab:not([aria-selected="true"]) .contador[data-tone="warning"] {
  background: var(--status-warning-bg);
  color: var(--text-warning);
}
.panel:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
  border-radius: var(--r-sm);
}
@media (prefers-reduced-motion: reduce) {
  .tab {
    transition: none;
  }
}
